import { Box, Typography } from '@mui/material';

const features = [
  { color: '#ff6f00', text: 'Provide great user experience' },
  { color: '#00acc1', text: 'Modern Technology' },
  { color: '#43a047', text: 'App Development' },
  { color: '#8e24aa', text: 'Web Development' },
];

export default function FeatureHighlights() {

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr 1fr' },
        gap: 3,
      }}
    >
      {features.map(({ color, text }) => (
        <Box
          key={text}
          sx={{
            p: 2,
            backgroundColor: '#1e1e1e',
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
            <span style={{ color }}>{'▌ '}</span>
            {text}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
